import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';

import { AppSharedModule } from '../../app-shared.module';
import { AdminAuthGuardService } from '../../providers/bridge-api/auth.service';
import { GroupService } from '../../providers/semantria-api/group.service';
import { GroupCreateDialogComponent } from './components/group-create-dialog/group-create-dialog.component';
import { GroupUsersComponent } from './components/group-users/group-users.component';
import { UserAddDialogComponent } from './components/user-add-dialog/user-add-dialog.component';
import { GroupSharedModule } from './group-shared.module';
import { GroupListComponent } from './pages/group-list.component';

@NgModule({
  declarations: [
    GroupListComponent,
    GroupCreateDialogComponent,
    GroupUsersComponent,
    UserAddDialogComponent,
  ],
  imports: [
    AppSharedModule,
    GroupSharedModule,
    RouterModule.forRoot(
      [
        {
          canActivate: [AdminAuthGuardService],
          path: 'user-groups',
          component: GroupListComponent,
        },
      ],
      { onSameUrlNavigation: 'reload' }
    ),
  ],
  providers: [GroupService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GroupModule {}
